import IFaturaCliente from "../interfaces/IFaturaCliente";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class FaturaClienteService {
    async getById(id: string) {
        return await api.get<IFaturaCliente>(`${resources.faturaCliente}/GetById/${id}`);
    }

    async create(data: any) {
        return await api.post<IFaturaCliente>(`${resources.faturaCliente}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.faturaCliente}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.faturaCliente}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.faturaCliente}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async approve(id: any) {
        return await api.put<any>(`${resources.faturaCliente}/Approve/${id}`);
    }

    async load(file: string) {
        return await api.put<any>(`${resources.faturaCliente}/Load/${file}`);
    }

    async downloadAll() {
        return await api.get("/");
    }

    async publish(data: any) {
        return await api.post<any>(`${resources.faturaCliente}/Publish`, data);
    }

    async getListaErros(filters: any) {
        return await api.get(`${resources.faturaCliente}/GetListaErros/${ToQueryString(filters)}`);
    }

    async getRelatorioConsumo(data: any) {
        return await api.get<IFaturaCliente>(`${resources.faturaCliente}/GetRelatorioConsumo/${ToQueryString(data)}`);
    }

    async confirm(data: any) {
        return await api.post<any>(`${resources.faturaCliente}/Confirm`, data);
    }
}

export default new FaturaClienteService();
